import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../cms/block/abstract-cms-block.component';

interface IDeliveryAddressCmsBlock extends NICmsContentComponent.IData {
    title?: string;
}

const config: Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'> = {
    id: 'delivery-address-cmsblock',
    block: {
        url: 'delivery-address-cmsblock'
    },
    onDemandOnly: true,
    name: 'Delivery address title',
    description: 'Delivery address title',
    fields: [
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Delivery address title',
            default: 'Delivery address'
        }
    ]
};

@ICmsComponent<DeliveryAddressCmsBlockComponent>(config)
@Component({
    selector: 'delivery-address-cmsblock',
    templateUrl: './delivery-address-cmsblock.component.html',
    styleUrl: './delivery-address-cmsblock.component.scss',
    standalone: true,
    imports: [ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeliveryAddressCmsBlockComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: IDeliveryAddressCmsBlock;

    override canDetach = false;
}
